import React, { useEffect, useRef } from "react";
import { useState } from "react";
import { Grid, Box, CssBaseline, Snackbar, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

import {
  mainLayoutStyles,
  routes,
  showNotification,
} from "../../../../constants";
import Sidebar from "../../../../common/Sidebar";
import DetailsPageHeader from "../../../../common/DetailsPageHeader";
import { useAuth } from "../../../../hooks";
import Scrollbars from "react-custom-scrollbars-2";
import { Toast } from "../../../../common/alert";
import { SearchBar } from "../../../OrganizationQuickTales/components/components";
import { AddContributorsTable } from "../../components/components";
import {
  // searchUsersFromFirebase,
  updateContributor,
  addContributorsInvites,
  // checkUserExist,
  // addContributor,
  checkContributorInviteExist,
  contributorsSearch,
} from "../../hooks/ContributorsHook";

import { AddAdminSendInviteModal } from "../../../Admins/components/components";
import { useContributorsContext } from "../../../../providers/OrganizationAdmin/ContributorsProvider";
import { sendgridEmail } from "../../../../modules/AreaManagement/hooks/AreaHook";
import ConfirmationModal from "../../../../common/ConfirmationModal";
import { getEmailTemplate } from "../../../../emails/EmailTemplate";
import { useOrganizationContext } from "../../../../providers/OrganizationAdmin/OrganizationProvider";
import { useCommonContext } from "../../../../providers/CommonProvider";
const AddContributor = () => {
  const { currentUser, organizationId } = useAuth();
  const { setLoading, handleGetAllContributors, loading } =
    useContributorsContext();
  const { GAUsers, handleGetAllGAUsers } = useContributorsContext();
  const { handleOnSendNotification } = useCommonContext();
  const { currentOrganization, handleGetOrganization } =
    useOrganizationContext();
  const scrollbarsRef = useRef(null);
  const navigate = useNavigate();

  const [selected, setSelected] = useState(null);
  const [searchValue, setSearchValue] = useState(null);
  const [searchedUsers, setSearchedUsers] = useState([]);

  const [sendInviteModal, setSendInviteModal] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snakbarMessgae, setSnakbarMessgae] = useState("");
  const [addContributorModal, setAddContributorModal] = useState(false);
  const [confirmInviteModal, setConfirmInviteModal] = useState(false);
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    handleGetOrganization();
  }, []);

  useEffect(() => {
    handleGetAllGAUsers();
  }, []);
  const handleSendInviteModalOpen = () => {
    setSendInviteModal(true);
  };
  const handleSendInviteModalClose = () => {
    setSendInviteModal(false);
  };
  const handleAddContributorModalOpen = (userData) => {
    setUserData(userData);
    setAddContributorModal(true);
  };
  const handleAddContributorModalClose = () => {
    setUserData(null);
    setAddContributorModal(false);
  };
  const handleConfirmInviteModalOpen = (userData) => {
    setUserData(userData);
    setConfirmInviteModal(true);
  };
  const handleConfirmInviteModalClose = () => {
    setUserData(null);
    setConfirmInviteModal(false);
  };

  const handleAddContributor = async () => {
    try {
      if (userData !== null) {
        setLoading(true);
        // Filter out the selected users'
        if (
          userData.organizations &&
          userData.organizations.includes(
            organizationId ? organizationId : currentUser.organization
          )
        ) {
          showNotification(
            "This User is already a contributor to this Organization."
          );
          // Toast(
          //   "success",
          //   "This User is already a contributor to this Organization."
          // );
        } else {
          let orgTemp = [
            organizationId ? organizationId : currentUser.organization,
          ];
          console.log("orgTemp:", orgTemp);
          let dataTemp = {
            organizations: userData.organizations
              ? [
                  ...userData.organizations,
                  organizationId ? organizationId : currentUser.organization,
                ]
              : orgTemp,
            // createdAt: new Date(),
            // approvalStatus: {
            //   status: "accepted",
            //   // status: "pending",
            //   updatedAt: new Date(),
            //   updatedBy: currentUser.id,
            // },
            // status: "pending",
            // addedToOrgDate: new Date(),
            // invitationToOrgDate: new Date(),
          };
          // let name = userData?.name?.split(" ");
          let inviteDataTemp = {
            organization: organizationId
              ? organizationId
              : currentUser.organization,
            status: "accepted",
            firstName: userData?.firstName,
            lastName: userData?.lastName,
            addedBy: currentUser.id,
            invitedUserEmail: userData.email,
            addedToOrgDate: new Date(),
            createdAt: new Date(),
            userName: userData?.userName,
            userId: userData?.id,
          };
          await updateContributor(userData.id, dataTemp);
          await addContributorsInvites(inviteDataTemp);
          console.log("dataTemp:", dataTemp);
          await handleGetAllContributors();
          await handleOnSendNotification({
            userId: userData?.id,
            userData: userData,
            data: {
              fromUserId: currentUser?.id,
              // fromUserId: fromUser?.userId,
              toUserId: userData?.id,
              title: `You are added as a contributor`,
              // title: `You are added as a contributor to ${organization.title}`,
              subTitle: `You are approved as a Contributor for ${currentOrganization?.name}, You can now submit QTs to ${currentOrganization?.name} from any QuickTale edit page.`,
              // subTitle: `You have been added as a contributor to ${currentOrganization?.name}, you can now submit QTs to ${currentOrganization?.name}`,
              type: "invites",
              subType: "contributor_request_accepted",
              docRef: "organizations",
              //organization id to which the user is added as contributor
              docRefId: organizationId
                ? organizationId
                : currentUser.organization ?? "",
            },
          });
          showNotification("User have been added as a Contributor");
          // Toast("success", "User have been added as a Contributor");
          navigate(routes.contributors);
        }
      }
    } catch (error) {
      console.log("error adding contributor:", error.message);
    } finally {
      setLoading(false);
      handleAddContributorModalClose();
    }
  };
  // const handleSendInvite = () => {
  //   handleSendInviteModalClose();
  //   setSnakbarMessgae("Invitation Sent!");
  //   setSnackbarOpen(true);
  // };

  const handleSendInvite = async () => {
    try {
      if (userData !== null) {
        setLoading(true);
        let orgTemp = organizationId
          ? organizationId
          : currentUser.organization;
        let nameTemp = userData?.name?.split(" ");
        let dataTemp = {
          organization: orgTemp,
          status: "pending",
          firstName: nameTemp && nameTemp[0] ? nameTemp[0] : "",
          lastName: nameTemp && nameTemp[1] ? nameTemp[1] : "",
          invitedBy: currentUser.id,
          invitedUserEmail: userData.email,
          userName: "",
          createdAt: new Date(),
          invitationToOrgDate: new Date(),
          // addedToOrgDate: new Date()
        };
        let id = null;
        let userExist = await checkContributorInviteExist(userData.email);
        if (userExist.status) {
          id = userExist.id;
        } else {
          const response = await addContributorsInvites(dataTemp);
          id = response.id;
        }
        // let dataTemp = {
        //   // organization: userData.organization
        //   //   ? [...userData.organization, currentUser.organization]
        //   //   : orgTemp,
        //   // // status: "pending",
        //   approvalStatus: {
        //     status: "pending",
        //     updatedAt: new Date(),
        //     updatedBy: currentUser.id,
        //   },
        //   addedToOrgDate: new Date(),
        //   firstName: userData.name,
        //   email: userData.email,
        //   invitationToOrgDate: new Date(),
        //   createdAt: new Date(),
        // };

        // let id = null;
        // let userExist = await checkUserExist(userData.email);
        // if (userExist.status) {
        //   const response = await updateContributor(userExist.id, dataTemp);
        //   id = userExist.id;
        // } else {
        //   const response = await addContributor(dataTemp);
        //   id = response.id;
        // }

        let redirectUrl = window.location.origin + "/accept-contributor-invite";
        redirectUrl = redirectUrl + "/" + id + "/accepted";
        const htmlContent = getEmailTemplate(
          userData,
          // currentOrganization?.orgEmail, org email
          "Contributor",
          redirectUrl ,
          currentOrganization?.name,
          currentUser?.email,
        );
        let name = userData.name;
        let text = userData.message;
        const message = {
          to: userData.email,
          from: process.env.REACT_APP_FROM_EMAIL,
          subject: "Contributor Invite",
          html: htmlContent,
        };

        let responseTemp = await sendgridEmail(message);

        if (responseTemp) {
          handleSendInviteModalClose();
          setSnakbarMessgae("Invitation Sent!");
          setSnackbarOpen(true);
        }
        await handleGetAllContributors();
        showNotification("User have been added as a Contributor");
      }
    } catch (error) {
      console.log("error sending invite:", error.message);
      Toast("error", error.message);
      handleSendInviteModalClose();
    } finally {
      setLoading(false);
      handleConfirmInviteModalClose();
    }
  };

  const handleSearchUsers = async (e) => {
    try {
      const searchTerm = e.target.value;
      setSearchValue(e.target.value);
      if (searchTerm.trim() === "") {
        setSearchedUsers([]);
        setSearchValue(null);
      } else {
        let usersSearchTemp = await contributorsSearch(GAUsers, searchTerm);
        console.log("searched:", usersSearchTemp);
        setSearchedUsers(usersSearchTemp);
      }
    } catch (error) {
      console.log("error searching users:", error.message);
    }
    // const searchTerm = e.target.value;
    // setSearchValue(e.target.value);
    // // const searchTerm = e.target.value.toLowerCase();
    // if (searchTerm.trim() === "") {
    //   setSearchedUsers([]);
    //   setSearchValue(null);
    //   return;
    // }

    // try {
    //   let users = await searchUsersFromFirebase(searchTerm);
    //   console.log("searched users::", users);
    //   setSearchedUsers(users);
    // } catch (error) {
    //   console.error("error searching users:", error.message);
    // }
  };

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <DetailsPageHeader
        mainTitle={`Add Contributor`}
        bgColor="#fff"
        // buttonText={"Edit"}
        // editEnabled={true}
        // cancelButton={true}
        // submitButtonText={"Add Area"}
        // handleSave={() => navigate(routes.areaManagement)}
      />
      <Sidebar />
      <Snackbar
        // anchorOrigin={{ vertical, horizantal }}
        open={snackbarOpen}
        onClose={() => setSnackbarOpen(false)}
        message={snakbarMessgae}
        // key={vertical + horizantal}
      />
      <Grid container style={{ ...mainLayoutStyles, background: "#fff" }}>
        <Grid container direction={"column"} style={subContainerStyles}>
          {/*Data card/container section*/}
          {/* <AddAreaDataFieldsSection
            areaDetails={areaDetails}
            setAreaDetails={setAreaDetails}
          /> */}
          <Grid container direction={"column"}>
            <SearchBar
              selected={selected}
              setSelected={setSelected}
              handleSearch={handleSearchUsers}
            />
            {searchedUsers.length && searchedUsers.length > 0 ? (
              <Scrollbars
                style={scrollbar}
                autoHide={true}
                ref={scrollbarsRef} // Assign the ref to Scrollbars instance
                renderThumbVertical={({ style, ...props }) => (
                  <div
                    {...props}
                    style={{
                      ...style,
                      ...scrollbarprops,
                    }}
                  />
                )}
              >
                <AddContributorsTable
                  selected={selected}
                  setSelected={setSelected}
                  searchedUsers={searchedUsers}
                  handleAddContributor={handleAddContributorModalOpen}
                />
              </Scrollbars>
            ) : searchValue ? (
              <Grid
                container
                direction={"column"}
                justifyContent={"center"}
                alignItems={"center"}
                style={{ height: "80vh" }}
              >
                <span style={{ fontFamily: "Avenir Book, sans-serif" }}>
                  No Results for ‘{searchValue}’
                </span>
                {/* <Button
                  variant="text"
                  onClick={handleSendInviteModalOpen}
                  style={inviteButtonStyles}
                >
                  Send Invite
                </Button> */}
              </Grid>
            ) : undefined}
          </Grid>
        </Grid>
      </Grid>
      <AddAdminSendInviteModal
        modalOpen={sendInviteModal}
        handleClose={handleSendInviteModalClose}
        handleSendInvite={handleConfirmInviteModalOpen}
        loading={loading}
      />
      <ConfirmationModal
        modalOpen={addContributorModal}
        handleClick={handleAddContributor}
        title={"You want to add this user as a contributor?"}
        handleClose={handleAddContributorModalClose}
        loading={loading}
      />
      <ConfirmationModal
        modalOpen={confirmInviteModal}
        handleClick={handleSendInvite}
        title={"Would you like to submit this contributor invite?"}
        handleClose={handleConfirmInviteModalClose}
        loading={loading}
      />
    </Box>
  );
};

export default AddContributor;

const subContainerStyles = {
  paddingLeft: 30,
  paddingRight: 30,
  marginTop: 50,
};

const inviteButtonStyles = {
  color: "#00A7CD",
  fontSize: 14,
  fontWeight: 700,
  textTransform: "none",
  fontFamily: "Avenir Book, sans-serif",
};

// const buttonStyles = {
//   //   marginLeft: "auto",
//   textTransform: "none",
//   background: "#00A7CD",
//   fontSize: 15,
//   fontWeight: 500,
//   marginTop: 100,
// };
const scrollbar = { width: "100%", height: "530px", marginLeft: "auto" };
const scrollbarprops = {
  width: "4px",
  backgroundColor: "#00A7CD",
  borderRadius: "2px",
};
